/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import NotificationRepostitory from 'repositories/NotificationRepository';

const initialState = {
  loading: false,
  offerings: [],
};

const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState,
  reducers: {
    sendNotificationStart(state) {
      state.loading = true;
    },
    sendNotificationSuccess(state) {
      state.loading = false;
    },
    sendNotificationFail(state) {
      state.loading = false;
    },
  },
});

export const { actions } = notificationSlice;

export default notificationSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const sendMessageNotification = async params => {
    dispatch(actions.sendNotificationStart());
    try {
      await NotificationRepostitory.create(params);
      dispatch(actions.sendNotificationSuccess());
    } catch (_error) {
      dispatch(actions.sendNotificationFail());
    }
  };

  return {
    sendMessageNotification,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/notificationSlice.js